import I18n from 'Pods/Shared/I18n'

export const getUnitLabel = (unitValue, locale = 'en') => {
  if (!unitValue) return ''

  return I18n.t(`itemPage.units.${unitValue}`, {
    ns: 'rails',
    lng: locale,
    defaultValue: unitValue,
  })
}

const normalizeKey = (value) => value?.toString().trim().toLowerCase()

const VISUAL_ATTRIBUTE_TOOLTIPS = {
  animated: 'The model includes animations (movement or actions) that can be played in supported software or engines.',
  rigged: 'The model has a skeleton or bone structure, making it ready for posing or animation.',
  'vr / ar / low-poly': 'The model is optimized for Virtual Reality (VR) and Augmented Reality (AR) applications, '
    + 'with a low polygon count for better performance.',
  pbr: 'Uses Physically Based Rendering materials, which give the model realistic lighting and surface properties.',
  'simulation-ready': 'The designer marked the model as suitable for physics or engineering simulation.',
  textures: 'The model includes image files (textures) that add color, patterns, or detail to its surfaces.',
  materials: 'The model has material settings that define how surfaces look (color, shine, transparency, etc.).',
  'uv mapping': 'The model\'s surfaces are mapped to a 2D image, allowing textures to display correctly.',
  'plugins used': 'Some external plugins were used to create the model. These may be required for full functionality.',
}

const GEOMETRY_TYPE_TOOLTIPS = {
  'polygon mesh': 'A model built from polygons (triangles or quads) connected in a mesh.',
  'subdivision ready': 'A polygon model designed to smooth cleanly when subdivision is applied.',
  nurbs: 'A model created with curved surfaces using mathematical splines, not polygons.',
  other: 'The model uses a different geometry type (e.g., voxels, point cloud).',
}

export const POLYGONS_TOOLTIP = 'The total number of polygons (flat shapes) that make up the 3D model.'
export const VERTICES_TOOLTIP = 'The number of points (corners) that define the shape of the model\'s polygons.'
export const PROVIDED_BY_DESIGNER_TOOLTIP = 'Information and details shared directly by the model\'s designer.'

export const getVisualAttributeTooltip = (detail) => VISUAL_ATTRIBUTE_TOOLTIPS[normalizeKey(detail)] || null

const resolveGeometryTypeLabel = (geometryType) => {
  if (typeof geometryType === 'string') {
    return geometryType
  }

  return ''
}

export const getGeometryTypeTooltip = (geometryType) => {
  const label = resolveGeometryTypeLabel(geometryType)

  if (!label) {
    return null
  }

  return GEOMETRY_TYPE_TOOLTIPS[normalizeKey(label)] || null
}

